import { lazy, Suspense, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { BarraDeDesfazer } from '../features/pedidos/fila/BarraDeDesfazer';
import { ProvedorDaBusca, useBusca } from './busca';
import { ProvedorDaConexao } from './conexao';
import { DialogoAtalhos } from './DialogoAtalhos';
import { ProvedorDoDesfazer } from './desfazer';
import css from './LayoutPainel.module.css';
import { LinhaDeEstado } from './LinhaDeEstado';
import { MenuLateral, TopoDoCelular } from './MenuLateral';
import { rotaPai, useAtalhosGlobais } from './useAtalhosGlobais';

// A busca "/" fica num pedaço à parte, baixado com o painel parado (PRECARREGAR_BUSCA_MS): assim o
// primeiro "/" abre na hora e o que se digita logo depois não cai na tela de trás.
const carregarBusca = () => import('../features/busca/BuscaDoBalcao');
const BuscaDoBalcao = lazy(carregarBusca);
const PRECARREGAR_BUSCA_MS = 1500;

/** Moldura do painel: os provedores do balcão valem para todas as telas, e o Desfazer é um só. */
export function LayoutPainel() {
  return (
    <ProvedorDaConexao>
      <ProvedorDoDesfazer>
        <ProvedorDaBusca>
          <Moldura />
        </ProvedorDaBusca>
      </ProvedorDoDesfazer>
    </ProvedorDaConexao>
  );
}

function Moldura() {
  const navegar = useNavigate();
  const { pathname } = useLocation();
  const busca = useBusca();
  const [atalhosAbertos, setAtalhosAbertos] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => void carregarBusca().catch(() => {}), PRECARREGAR_BUSCA_MS);
    return () => clearTimeout(id);
  }, []);

  // Com a busca aberta (ou ainda chegando), as letras são dela; o Esc só a fecha.
  useAtalhosGlobais({
    novoPedido: () => {
      if (!busca.aberta) navegar('/pedidos/novo');
    },
    buscar: busca.abrir,
    ajuda: () => {
      if (!busca.aberta) setAtalhosAbertos(true);
    },
    voltar: () => {
      if (busca.aberta) return busca.fechar();
      const pai = rotaPai(pathname);
      if (pai) navegar(pai);
    },
  });

  return (
    <div className={css.layout}>
      <TopoDoCelular />
      <MenuLateral aoAbrirAtalhos={() => setAtalhosAbertos(true)} />
      <main className={css.conteudo}>
        <LinhaDeEstado />
        <Outlet />
      </main>
      <BarraDeDesfazer />
      <DialogoAtalhos aberto={atalhosAbertos} aoFechar={() => setAtalhosAbertos(false)} />
      {busca.aberta && (
        <Suspense fallback={null}>
          <BuscaDoBalcao aoFechar={busca.fechar} />
        </Suspense>
      )}
    </div>
  );
}
